import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyToolbarComponent } from './toolbar.component';
import { SkyToolbarItemComponent } from './toolbar-item.component';
import { SkyToolbarSectionComponent } from './toolbar-section.component';


export class SkyToolbarModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    SkyToolbarComponent,
    SkyToolbarItemComponent,
    SkyToolbarSectionComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SkyToolbarComponent,
    SkyToolbarItemComponent,
    SkyToolbarSectionComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
